import React, { useEffect, useState } from 'react';
import useWarehouseOrderItemService from '../../../app/services/hooks/useWarehouseOrderItemService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import WarehouseOrderItemShowForm from './forms/WarehouseOrderItemShowForm';
import LazyLoading from '../../../components/LazyLoading';
import { WarehouseOrderItemDataForm, WarehouseOrderItemShowDataForm } from '../../../app/models/WarehouseOrderItem';

interface Props {
    warehouseOrderItemId: number;
    onError?: (message?: string) => void;
}

const WarehouseOrderItemShow = ({ warehouseOrderItemId, onError }: Props) => {
    const { fetchingShowWarehouseOrderItem, showWarehouseOrderItem } =
        useWarehouseOrderItemService();

    const [warehouseOrderItemShow, setWarehouseOrderItemShow] =
        useState<WarehouseOrderItemShowDataForm>({});

    useEffect(() => {
        if (warehouseOrderItemId) {
            show();
        }
    }, [warehouseOrderItemId]);

    const show = () => {
        showWarehouseOrderItem(warehouseOrderItemId, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseOrderItemShow(response.data.items);
            },
            onError: (response: ServiceResponse) => {
                onError && onError(response.message);
            }
        });
    };

    return !fetchingShowWarehouseOrderItem ? (
        <WarehouseOrderItemShowForm
            warehouseOrderItemShowForm={warehouseOrderItemShow}
        />
    ) : (
        <LazyLoading height={300} />
    );
};

export default WarehouseOrderItemShow;
